declare global {
    interface Window {
        turnstile?: NTurnstile.IApi;
        onloadTurnstileCallback: (() => void) | undefined;
    }
}

export namespace NTurnstile {
    export const SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback';

    export interface IApi {
        ready(callback: () => void): void;
        render(containerSelector: string, options: IOptions): string;
        remove(widgetId: string): void;
        reset(widgetId: string): void;
    }

    export enum EExecutionMode {
        render = 'render', // default
        execute = 'execute'
    }

    export enum ETheme {
        light = 'light',
        dark = 'dark',
        auto = 'auto' // default
    }

    export enum EAppearance {
        always = 'always', // default
        execute = 'execute',
        interactionOnly = 'interaction-only'
    }

    export interface IOptions {
        sitekey: string;
        callback?: (token: string) => void;
        'error-callback'?: (error: string) => void;
        execution?: EExecutionMode;
        'expired-callback'?: () => void;
        'timeout-callback'?: () => void;
        'unsupported-callback'?: () => void;
        theme?: ETheme;
        appearance?: EAppearance;
    }
}
